import { createAction, handleActions } from 'redux-actions';
import { takeLatest, call } from 'redux-saga/effects';
import * as prodAPI from '../../lib/api/prodapi';
import * as userAPI from '../../lib/api/userapi';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';

/**
 * 사용자 상태 저장 리덕스 모듈 
 */

/**
 * 액션 타입 정의 
 */
// 상품 클립
const [
    REQ_TYPE_USER_PROD_ADD,
    REQ_TYPE_USER_PROD_ADD_SUCCESS,
    REQ_TYPE_USER_PROD_ADD_FAILURE,
] = createRequestActionTypes('userProd/PROD_ADD');

const [
    REQ_TYPE_USER_PROD_DEL,
    REQ_TYPE_USER_PROD_DEL_SUCCESS,
    REQ_TYPE_USER_PROD_DEL_FAILURE,
] = createRequestActionTypes('userProd/PROD_DEL');

const [
    REQ_TYPE_USER_PROD_DEL_ALL,
    REQ_TYPE_USER_PROD_DEL_ALL_SUCCESS,
    REQ_TYPE_USER_PROD_DEL_ALL_FAILURE,
] = createRequestActionTypes('userProd/PROD_DEL_ALL');

const [
    REQ_TYPE_USER_PROD_CART_SOLD_INFO,
    REQ_TYPE_USER_PROD_CART_SOLD_INFO_SUCCESS,
    REQ_TYPE_USER_PROD_CART_SOLD_INFO_FAILURE,
] = createRequestActionTypes('userProd/REQ_TYPE_USER_PROD_CART_SOLD_INFO');

// 클립 상품 저장
const SET_CLIP_PROD_ID = 'userProd/SET_CLIP_PROD_ID';
// 좋아요 상품
const [PROD, PROD_SUCCESS, PROD_FAILURE] = createRequestActionTypes(
    'userProd/PROD',
);
// 장바구니 상품 선택 정보
const SET_CART_CHECK_INFO = 'userProd/SET_CART_CHECK_INFO';
const SET_CART_INPUT_INFO = 'userProd/SET_CART_INPUT_INFO';
const SET_CART_HISTORY_KEY = 'userProd/SET_CART_HISTORY_KEY';

//상품 클립 추가
export const setUserProdAddAction = createAction(REQ_TYPE_USER_PROD_ADD, (email, prodid) => {
    return { email, prodid }
});

//상품 클립 삭제
export const setUserProdDelAction = createAction(REQ_TYPE_USER_PROD_DEL, (email, prodid) => {
    return { email, prodid }
});

export const setUserProdDelAllAction = createAction(REQ_TYPE_USER_PROD_DEL_ALL, (email, brandid) => {
    return { email, brandid }
});

export const setClipProdIdAction = createAction(SET_CLIP_PROD_ID);

export const prodAction = createAction(PROD, (email) => {
    return { email }
});
//로컬에 저장된 장바구니 품절 정보 얻어오기
export const getLocalCartSoldInfoAction = createAction(REQ_TYPE_USER_PROD_CART_SOLD_INFO);

// 장바구니 상품 선택 정보
export const setCartCheckInfoAction = createAction(SET_CART_CHECK_INFO);
export const setCartInputInfoAction = createAction(SET_CART_INPUT_INFO);
export const setCartHistoryKeyAction = createAction(SET_CART_HISTORY_KEY);

/**
 * Networ 통신 : Saga Lib 사용 
 */
const ProdSaga = createRequestSaga(PROD, userAPI.prod);
//상품 클립 추가
const prodAddSaga = createRequestSaga(REQ_TYPE_USER_PROD_ADD, prodAPI.prodAdd);
const prodDelSaga = createRequestSaga(REQ_TYPE_USER_PROD_DEL, prodAPI.prodDel);
const prodDelAllSaga = createRequestSaga(REQ_TYPE_USER_PROD_DEL_ALL, prodAPI.prodDelAll);
const prodCartSoldInfo = createRequestSaga(REQ_TYPE_USER_PROD_CART_SOLD_INFO, prodAPI.getCartSoldInfo);

export function* userProdSaga() {
    yield takeLatest(PROD, ProdSaga);
    yield takeLatest(REQ_TYPE_USER_PROD_ADD, prodAddSaga);
    yield takeLatest(REQ_TYPE_USER_PROD_DEL, prodDelSaga);
    yield takeLatest(REQ_TYPE_USER_PROD_DEL_ALL, prodDelAllSaga);
    yield takeLatest(REQ_TYPE_USER_PROD_CART_SOLD_INFO, prodCartSoldInfo);
}

export const cart_check_info = {
    brnd_id : null,
    prdct_id : null,
    qty : null,
    es_opt_pirce: null, //sale
    prdct_price: null, //normal
    opt_id : null,
    isSoldOut: false,
}

/**
 * 리덕스 모듈 초기값 
 */
const initialState = {
    clipProdIds: null, //좋아요 상품
    prodClipResult: null,       //상품 클립(좋아요) 결과
    prodCartSoldInfo:null, //로컬 장바구니 상품 품절 정보
    prodCartCheckInfo: [], //장바구니 선택 정보
    prodCartInputInfo: [], //장바구니 희망가 input 정보
    cartHistoryKey:"",
    error: null,

};

/**
 * 리덕스 액션 연결 
 */
const userProdReducer = handleActions(
    {
        [SET_CLIP_PROD_ID]: (state, { payload: clipProdIds }) => ({
            ...state,
            clipProdIds: clipProdIds,
        }),
        [PROD_SUCCESS]: (state, { payload: clipProdIds }) => {
            let data = [];
            if (clipProdIds !== null & clipProdIds.length > 0) {
                clipProdIds.forEach(element => {
                    data.push(element.prdct_id)

                });
            }
            return {
                ...state,
                clipProdIds: data,
            }

        },
        [PROD_FAILURE]: (state, { payload: error }) => {
            return {
                ...state,
                error: error,
                clipProdIds: null,
            }
        },
        [REQ_TYPE_USER_PROD_ADD_SUCCESS]: (state, { payload: prodClipResult }) => {
            return ({

                ...state,
                error: null,
                prodClipResult: prodClipResult,
            })
        },
        [REQ_TYPE_USER_PROD_ADD_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state,
                error: error,
                prodClipResult:null,
            })
        },
        [REQ_TYPE_USER_PROD_DEL_SUCCESS]: (state, { payload: prodClipResult }) => {
            return ({

                ...state,
                error: null,
                prodClipResult: prodClipResult,
            })
        },
        [REQ_TYPE_USER_PROD_DEL_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state,
                error: error,
                prodClipResult: null,
            })
        },
        [REQ_TYPE_USER_PROD_DEL_ALL_SUCCESS]: (state, { payload: prodClipResult }) => {
            return ({

                ...state,
                error: null,
                prodClipResult: prodClipResult,
            })
        },
        [REQ_TYPE_USER_PROD_DEL_ALL_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state,
                error: error,
                prodClipResult: null,
            })
        },
        [REQ_TYPE_USER_PROD_CART_SOLD_INFO_SUCCESS]: (state, { payload: prodCartSoldInfo }) => {
            return ({

                ...state,
                error: null,
                prodCartSoldInfo: prodCartSoldInfo,
            })
        },
        [REQ_TYPE_USER_PROD_CART_SOLD_INFO_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state,
                error: error,
                prodCartSoldInfo: null,
            })
        },
        [SET_CART_CHECK_INFO]: (state, { payload: checkInfo }) => {
            return ({
                ...state,
                prodCartCheckInfo: checkInfo,
            })
        },
        [SET_CART_INPUT_INFO]: (state, { payload: inputInfo }) => {
            return ({
                ...state,
                prodCartInputInfo: inputInfo,
            })
        },
        [SET_CART_HISTORY_KEY]: (state, { payload: key }) => {
            return ({
                ...state,
                cartHistoryKey: key,
            })
        },
    },
    initialState,
);

export default userProdReducer;